<template>
  <div class="footer-container">
    <div id="footer_sidebar">
      <div>IVA: {{ $filters.currency(order.vatAmount) }}</div>
      <div>{{ $filters.currency(order.amount) }}</div>
    </div>
      <div v-if="showPdvDetailFooter" id="footer_content_details">
      <ButtonBistro variant="gradient-green" :text="order.isTableOrder ? 'COBRAR MESA' : 'COBRAR'" @handleClick="handleGoToCheckout" />
      <ButtonBistro v-if="order.isTableOrder && order.status !== orderStatus.CLOSED" variant="gradient-red" text="CERRAR MESA" @handleClick="handleCloseTable" />
      <ButtonBistro variant="gradient-gray" text="IMPRIMIR" @handleClick="handlePrintPartialTicket" />
    </div>
    <div v-if="showCheckoutFooter" id="footer_content_checkout">
      <ButtonBistro variant="gradient-green" :text="isExactPayment ? 'PAGO EXACTO' : 'PAGO'"
        @handleClick="selectPaymentMethodAndPay" />
    </div>
    <div v-if="order.isTableOrder && order.status == orderStatus.CLOSED && !showCheckoutFooter" id="footer_content_checkout">
      <ButtonBistro variant="gradient-blue" text="REABRIR MESA" @handleClick="handleReopenTable" />
    </div>
    <ModalCreditsCards @onCardSelected="confirmCardPayment" />
    <PaymentMethods
      :order="order"
      :shopCode="shopCode"
      @paid="onPaid"
      @open-cards-modal="openCardsModal"
    />
  </div>
</template>

<script>
import router from "@/router";
import ButtonBistro from "@/features/shared/components/ButtonBistro.vue"
import shopCommons from "../../shared/mixins/shopCommons.vue";
import printerCommons from "../../shared/mixins/printerCommons.vue";
import ticketCommons from "../mixins/ticketCommons.vue";
import { toast } from "vue3-toastify";
import { updateOrder } from "../../shared/repositories/orders/ordersService.js";
import { ORDER_STATUS } from "../../shared/utils/orderStatuses.js";
import mixModals from "@/mixins/mixModals.vue";
import ModalCreditsCards from "../components/modals/ModalCreditsCards.vue";
import payCommons from '../mixins/payCommons.vue';
import { getCategories } from "../../shared/repositories/products/productsService";
import { getFormattedQuantity } from "../../shared/repositories/products/productsService";
import PaymentMethods from "./PaymentMethods.vue";
 
export default {
  name: 'FooterOrderDetails',
  mixins: [shopCommons, printerCommons, mixModals, payCommons, ticketCommons],
  components: {
    ButtonBistro,
    ModalCreditsCards,
    PaymentMethods
  },
  props: {
    order: {
      type: Object,
      required: true
    },
  },
  methods: {
    async handlePrintPartialTicket() {
      if(this.order.products.length === 0) {
        toast.error('Seleccione al menos un producto.');
        return;
      }

      const settings = localStorage.getItem("printersConfig");
      if (!settings) {
        toast.error('No tienes impresoras configuradas.');
        return;
      }
      try {
        var parsedSettings = JSON.parse(settings);
      } catch (error) {
        toast.error('No tienes impresoras configuradas.');
        return;
      }
      // Verifica si todas las impresoras están sin configurar
      const allPrintersUnconfigured = Object.values(parsedSettings).every(
        (printer) => printer.label === "Ninguna"
      );

      if (allPrintersUnconfigured) {
        toast.error('No tienes impresoras configuradas.');
        return;
      }
      
      let productsToCounter = [];
      let productsToKitchen = [];
      let productsToAdditional = [];
      let order = this.order;
      const categories = await getCategories(this.shopCode);
      const isReprint = order.products.every(element => element.quantityToPrintInPartialTicket === 0);
      order.products.forEach(element => {
        if (element.quantityToPrintInPartialTicket > 0 || isReprint) {

          const category = categories?.filter(x => x.name == element.department)[0];
   
          let row;
          if (element.weightable) {
            if (isReprint) {
              // Para reimpresiones, usa el quantity 
              row = this.replaceSpecialChars(getFormattedQuantity({ ...element, quantity: element.quantity }) + " " + element.name);
            } else {
              // Para impresiones normales, usa quantityToPrintInPartialTicket
              row = this.replaceSpecialChars(getFormattedQuantity({ ...element, quantity: element.quantityToPrintInPartialTicket }) + " " + element.name);
            }
          } else {
            // Para productos no pesables
            row = this.replaceSpecialChars((isReprint ? element.quantity : element.quantityToPrintInPartialTicket) + " " + element.name);
          }
          if (element.comment) row = `${row} \n   ${this.replaceSpecialChars(element.comment)}`

          if (category?.hasToPrintOnCounter) {
            productsToCounter.push(row);
          }
          if (category?.hasToPrintInKitchen) {
            productsToKitchen.push(row);
          }
          if (category?.hasToPrintOnAdditionalPrinter) {
            productsToAdditional.push(row);
          }

          element.quantityToPrintInPartialTicket = 0;

        }
      });

      if (productsToCounter.length > 0) {
        await this.printInCounter(this.generatePartialOrReprintTicket(this.order, productsToCounter, 'MOSTRADOR', isReprint));
      }
      if (productsToKitchen.length > 0) {
        await this.printInKitchen(this.generatePartialOrReprintTicket(this.order, productsToKitchen, 'COCINA', isReprint));
      }
      if (productsToAdditional.length > 0) {
        await this.printInAdditional(this.generatePartialOrReprintTicket(this.order, productsToAdditional, 'ADICIONAL', isReprint));
      }
      this.$emit('updateCurrentOrder', order);
    },
    async handleGoToCheckout() {
      if (!this.ensureCashboxOpenToPay()) return;
      // Verifica si quedan productos pendientes por imprimir
      const pendingProducts = this.order.products.some(element => element.quantityToPrintInPartialTicket > 0);

      // Si hay productos pendientes, imprime el ticket parcial
      if (pendingProducts) {
        await this.handlePrintPartialTicket();
      }
      if (this.order.products[0]) {
        router.push("/pdv/order/checkout/" + this.shopCode + "/" + this.order.id);
      }
      else toast.error('Seleccione al menos un producto')
    },
    async handleCloseTable() {
      if (this.order.products.length === 0) {
       toast.error('Seleccione al menos un producto')
       return;
      }
      // Cambiar el status de la orden a 'closed'
      const updatedOrder = { ...this.order, status: ORDER_STATUS.CLOSED };
      await updateOrder(this.shopCode, updatedOrder);
      
      // Actualizar el estado global
      this.$pdv.setOrder(updatedOrder);
      
      // Emitir evento para actualizar la orden en el componente padre
      this.$emit('updateCurrentOrder', updatedOrder);
      await this.printInCounter(this.generateCloseOrderTicket(this.order));
      toast.success('Mesa cerrada exitosamente');
    },

    async handleReopenTable() {
        // Cambiar el status de la orden de 'closed' a 'active'
        const updatedOrder = { ...this.order, status: ORDER_STATUS.ACTIVE };
        await updateOrder(this.shopCode, updatedOrder);
        
        // Actualizar el estado global
        this.$pdv.setOrder(updatedOrder);
        toast.success('Mesa reabierta exitosamente');
        
        // Emitir evento para actualizar la orden en el componente padre
        this.$emit('updateCurrentOrder', updatedOrder);
            
    },

    async confirmCardPayment(payload) {
      const order = this.order
      order.payments[0].paymentDescription = payload.selectedCard
      order.payments[0].authCode = payload.authCode
      order.payments[0].receivedPaidAmount = this.order.amount
      await updateOrder(this.shopCode, order);
      this.$pdv.setIsExactPayment(true)

      this.handleOrderPaid()

    }, 
    openCardsModal() {
      this.openNonDismissibleModal('#modalCreditsCards');
    },
    onPaid({ authCode }) {
      const order = this.order;
      order.payments[0].authCode = authCode;
      updateOrder(this.shopCode, order);
      this.handlePaymentSuccess();
    },
    async handlePaymentSuccess() {
      const order = this.order
      order.payments[0].receivedPaidAmount = this.order.amount
      await updateOrder(this.shopCode, order);
      this.$pdv.setIsExactPayment(true)

      this.handleOrderPaid()
    },
  },
  
  computed: {
    orderStatus() {
      return ORDER_STATUS;
    },
    isExactPayment() {
      return this.$pdv.getIsExactPayment;
    },
    showPdvDetailFooter() {
      const baseUrl = '/pdv/order/details/';
      return this.$route.path.startsWith(baseUrl);
    },
    showCheckoutFooter() {
      const baseUrl = '/pdv/order/checkout/';
      return this.$route.path.startsWith(baseUrl);
    },
  }
};
</script>

<style lang="scss">


.footer-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  box-shadow: 0px -4px 8px rgba(128, 128, 128, 0.411);
  font-family: 'Rubik-Regular';
}

#footer_sidebar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  height: 100%;
  width: 460px;
  background-color: $lightColorBg;
  color: #909699;
  padding: 16px;

  >div {
    font-weight: 700;
  }

  > :first-child {
    font-size: 22px;
  }

  > :last-child {
    font-size: 30px;
  }
}

#footer_content_checkout,
#footer_content_details {
  height: 100%;
  background-color: $lightColorBg;
  align-items: center;

  .button-bistro {
    border-radius: 0;
    width: 170px;
    height: 80px;
    justify-content: center;
  }
}
</style>
